import {
  ChatMessagePayloadAttachment,
  ChatMessagePayloadConference,
  ChatMessagePayload,
} from "@jugl-web/rest-api";
import { MessageReactionSummary } from "@web-src/modules/chats/utils/getChatMessageReactionsSummary";
import { createContext } from "react";
import { ChatMessageBubbleStatus } from "../../types/ChatMessageBubbleStatus";
import { ChatMessageReplyInfo } from "../../types/ChatMessageReplyInfo";
import { ChatMessageBubbleAction } from "../../types/ChatMessageBubbleAction";

export interface ChatMessageBubbleContextValue {
  entityId: string;

  // Base info
  chatId?: string;
  messageId: string;
  messageClientId?: string;
  messageFrom: string;
  messagePayloadVersion?: number;
  isOutgoing: boolean;
  isDeleted?: boolean;
  deletedBy?: ChatMessagePayload["deleted_by"];
  isUnsupported?: boolean;
  isForwarded?: boolean;
  isEdited: boolean;
  readOnly: boolean;
  outgoingStatus?: ChatMessageBubbleStatus;
  messageTextBody?: string;
  timestamp: string;
  isGroupChat: boolean;
  isError?: boolean;
  isPending?: boolean;

  // Attachments
  isTusDownloadAvailable?: boolean;
  isAttachmentOpeningDisabled?: boolean;

  // Chats related
  attachments?: ChatMessagePayloadAttachment[];
  conferenceInfo?: ChatMessagePayloadConference;
  replyInfo?: ChatMessageReplyInfo;
  previewUrl?: string;
  getAttachmentUrls: (attachment: ChatMessagePayloadAttachment) => {
    preview: string;
    stream: string;
  };

  // Actions
  availableActions?: ChatMessageBubbleAction[];
  triggerAction: (action: ChatMessageBubbleAction) => void;
  triggerReaction: (reaction: string) => void;
  onReplyPreviewClick?: (replyInfo: ChatMessageReplyInfo) => void;
  onAvatarClick?: (userId: string) => void;
  onRequestResend?: () => void;
  onDeleteAttachment?: (attachmentId: string) => void;

  // Reactions
  isReactionDetailsDisabled?: boolean;
  customReactions?: string[];
  reactions?: {
    summary: MessageReactionSummary[];
    myReactions: string[];
  };

  // Custom
  isMediaMessageOnly: boolean;
  isPinned?: boolean;
  isMessageActionsDisabled?: boolean;
  isHighlighted?: boolean;
  isPreview?: boolean;
  showOutgoingSenderDetails?: boolean;
  senderName?: string;
  senderImage?: string;
  senderAvatarName?: string;

  // Selection
  isSelectable?: boolean;
  isSelected?: boolean;
  onSelect?: (messageId: string, isSelected: boolean) => void;

  // Restrictions
  hasContentProtectionRestriction?: boolean;
  hasBroadcastChatRestriction?: boolean;

  // Grouping
  groupInfo?: {
    isFirst?: boolean;
    isLast?: boolean;
  };
}

export const ChatMessageBubbleContext =
  createContext<ChatMessageBubbleContextValue | null>(null);
